export default {
      id: "forms-check-usage",
      viewBox: "0 0 12 9",
      url: __webpack_public_path__ + "sprite.svg#forms-check",
      toString: function () {
        return this.url;
      }
    }